import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Link } from "react-router-dom";
import "./App.css";
import Resume from "./components/Resume";
import Gate from "./components/Gate";
import Admin from "./components/Admin";

const SiteFooter = () => (
  <footer className="no-print max-w-[1000px] mx-auto px-4 py-6 text-center">
    <Link to="/admin" className="text-[12px] uppercase tracking-widest text-[var(--muted)] hover:text-[var(--ink)] transition-colors">
      Admin
    </Link>
  </footer>
);

const Home = () => {
  const [granted, setGranted] = useState(
    () => localStorage.getItem("resumeAccessGranted") === "true"
  );

  if (!granted) return <Gate onGranted={() => setGranted(true)} />;

  return (
    <>
      <Resume />
      <SiteFooter />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
